import React, { Component } from 'react';
import { connect } from 'react-redux';
import { TiCalendar } from 'react-icons/ti';
import DatePicker from 'react-datepicker';

import {
  renderDecrementButton,
  renderIncrementButton,
  renderNextButton,
  renderPaginationButtons,
  renderPrevButton,
  renderTableHeader,
  renderTableData,
} from './tableHelper';
import { fetchAgentReport } from '../../store/actions/agentActions';
import { exportAgentReportToExcel } from '../../util/axiosHelper';

import formFields from '../../util/formFields';

import 'react-datepicker/dist/react-datepicker.css';
import './tables.css';

export class CSRAgentReports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: new Date(new Date() - 24 * 60 * 60 * 1000 * 7),
      endDate: new Date(),
      currentPage: 1,
      itemsPerPage: 5,
      upperPageBound: 3,
      lowerPageBound: 0,
      pageBound: 3,
    };
    this.handleFromChange = this.handleFromChange.bind(this);
    this.handleToChange = this.handleToChange.bind(this);
    this.handlePaginateClick = this.handlePaginateClick.bind(this);
    this.handlePrevClick = this.handlePrevClick.bind(this);
    this.handleDecrementClick = this.handleDecrementClick.bind(this);
    this.handleNextClick = this.handleNextClick.bind(this);
    this.handleIncrementClick = this.handleIncrementClick.bind(this);
  }

  handleFromChange(date) {
    this.setState({
      startDate: date,
    });
  }

  handleToChange(date) {
    this.setState({
      endDate: date,
    });
  }

  handleButtonClick(agentData, fetchAgentReport) {
    const { startDate, endDate } = this.state;
    const { Id } = agentData;
    fetchAgentReport(Id, startDate.toJSON().split('T')[0], endDate.toJSON().split('T')[0]);
  }

  handlePaginateClick(event) {
    this.setState({
      currentPage: Number(event.target.id),
    });
  }

  handlePrevClick() {
    const { lowerPageBound, upperPageBound, pageBound } = this.state;
    let currentPage = this.state.currentPage - 1;
    if (currentPage <= lowerPageBound) {
      const lowPageBound = lowerPageBound - pageBound;
      const upPageBound = upperPageBound - pageBound;
      this.setState({ lowerPageBound: lowPageBound });
      this.setState({ upperPageBound: upPageBound });
    }
    this.setState({ currentPage });
  }

  handleDecrementClick() {
    const { lowerPageBound, upperPageBound, pageBound } = this.state;
    const lowPageBound = lowerPageBound - pageBound;
    const upPageBound = upperPageBound - pageBound;
    const currentPage = upPageBound;

    this.setState({ lowerPageBound: lowPageBound });
    this.setState({ upperPageBound: upPageBound });
    this.setState({ currentPage });
  }

  handleNextClick() {
    const { lowerPageBound, upperPageBound, pageBound } = this.state;
    let currentPage = this.state.currentPage + 1;
    if (currentPage > upperPageBound) {
      const lowPageBound = lowerPageBound + pageBound;
      const upPageBound = upperPageBound + pageBound;
      this.setState({ lowerPageBound: lowPageBound });
      this.setState({ upperPageBound: upPageBound });
    }
    this.setState({ currentPage });
  }

  handleIncrementClick() {
    const { lowerPageBound, upperPageBound, pageBound } = this.state;
    const lowPageBound = lowerPageBound + pageBound;
    const upPageBound = upperPageBound + pageBound;
    const currentPage = lowPageBound + 1;

    this.setState({ lowerPageBound: lowPageBound });
    this.setState({ upperPageBound: upPageBound });
    this.setState({ currentPage });
  }

  render() {
    const { agentData, data, fetchAgentReport, onBackButtonClick, onCancelButtonClick } = this.props;
    const { currentPage, endDate, itemsPerPage, lowerPageBound, startDate, upperPageBound } = this.state;
    const { csrAgentReportTableHeaders: headerData } = formFields;
    const agentId = agentData.Id;

    const totalPages = Math.ceil(data.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

    return (
      <div className="reports-list-container">
        <div className="agent-report-datepicker-container">
          <div className="from-date-container">
            <span>
              History: &nbsp; &nbsp;
              <button
                className="form-button"
                onClick={() =>
                  exportAgentReportToExcel({
                    agentId,
                    fromDate: startDate.toJSON().split('T')[0],
                    toDate: endDate.toJSON().split('T')[0],
                  }).then(res => {
                    if (res && res.data) {
                      const url = window.URL.createObjectURL(
                        new Blob([res.data], {
                          type: 'application/vnd.ms-excel',
                        })
                      );
                      const link = document.createElement('a');
                      link.href = url;
                      link.setAttribute('download', 'AgentReport.xls');
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                    }
                  })
                }
              >
                Export to Excel
              </button>
            </span>
            <div>
              <span>From Date:</span>
              &nbsp; &nbsp;
              <label>
                <DatePicker
                  selected={this.state.startDate}
                  selectsStart
                  dateFormat="yyyy-MM-dd"
                  startDate={this.state.startDate}
                  endDate={this.state.endDate}
                  onChange={this.handleFromChange}
                />
                &nbsp;
                <TiCalendar size={20} color="#cc0505" />
              </label>
            </div>
          </div>
          <div className="to-date-container">
            <div>
              <span>To Date: </span>
              &nbsp; &nbsp;
              <label>
                <DatePicker
                  selected={this.state.endDate}
                  selectsEnd
                  dateFormat="yyyy-MM-dd"
                  startDate={this.state.startDate}
                  endDate={this.state.endDate}
                  onChange={this.handleToChange}
                />
                &nbsp;
                <TiCalendar size={20} color="#cc0505" />
              </label>
            </div>
            <button
              name="dateRangeButton"
              className="form-button"
              onClick={() => {
                this.handleButtonClick(agentData, fetchAgentReport);
              }}
            >
              View Selected Date Range
            </button>
          </div>
        </div>
        <div className="table-container">
          <table>
            <thead>
              <tr>{renderTableHeader(headerData)}</tr>
            </thead>
            <tbody>{renderTableData(headerData, currentItems)}</tbody>
          </table>
        </div>
        <div className="reports-list-buttons-container">
          <button name="backButton" className="search-button leftButton" onClick={onBackButtonClick}>
            Back
          </button>
          <div className="page-numbers-container">
            <ul id="page-numbers">
              {renderPrevButton(currentPage, totalPages, this.handlePrevClick)}
              {renderDecrementButton(lowerPageBound, this.handleDecrementClick)}
              {renderPaginationButtons(
                data,
                currentPage,
                itemsPerPage,
                lowerPageBound,
                upperPageBound,
                this.handlePaginateClick
              )}
              {renderIncrementButton(totalPages, upperPageBound, this.handleIncrementClick)}
              {renderNextButton(currentPage, totalPages, this.handleNextClick)}
            </ul>
          </div>
          <button name="cancelButton" className="search-button" onClick={onCancelButtonClick}>
            Cancel
          </button>
        </div>
      </div>
    );
  }
}

export default connect(null, { fetchAgentReport })(CSRAgentReports);
